import { FieldType } from "../../type-system/FieldType";
import {
  ShopifyDiscountKey,
  ShopifyShopKey,
  ShopifyDiscountCustomerGetsCollectionToDiscountKey,
  ShopifyDiscountCustomerGetsCollectionKey,
  ShopifyCollectionKey,
  ShopifyDiscountCustomerGetsCollectionToCollectionKey,
  ShopifyDiscountCustomerGetsCollectionToShopKey,
} from "./keys";
import { ShopifyDominion } from "./ShopifyDominion";
import type { ConnectionModelSpecVersion, ShopifyApiVersion } from "./ShopifyMetadata";
import { buildConnectionSpec } from "./ShopifyMetadata";

const specs: ConnectionModelSpecVersion = {
  key: ShopifyDiscountCustomerGetsCollectionKey,
  "2023-07": {
    name: "Shopify Discount Customer Gets Collection",
    fields: [
      {
        name: "ID",
        fieldType: FieldType.ID,
      },
      {
        name: "Discount",
        fieldType: FieldType.BelongsTo,
        key: ShopifyDiscountCustomerGetsCollectionToDiscountKey,
        configuration: {
          relatedModelKey: ShopifyDiscountKey,
        },
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "discountId",
            skipGraphQLSelection: true,
          },
        },
      },
      {
        name: "Collection",
        fieldType: FieldType.BelongsTo,
        key: ShopifyDiscountCustomerGetsCollectionToCollectionKey,
        configuration: {
          relatedModelKey: ShopifyCollectionKey,
        },
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "collectionId",
            skipGraphQLSelection: true,
          },
        },
      },
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifyDiscountCustomerGetsCollectionToShopKey,
        configuration: {
          relatedModelKey: ShopifyShopKey,
        },
      },
    ],
    // in somewhat of a gross an anti-pattern, because shopifyDiscount is already synced through
    // a complicated custom sync, we also sync this model as part of it
    // although note, that we also need to do this sync on discount webhooks since shopify doesn't
    // send the full discount object in the webhook; so the actual place where the syncing happens is
    // in ShopifyDiscountGraphQLHandler
    syncConfig: { type: "inherit" },
  },
};

export const ShopifyDiscountCustomerGetsCollection = ({ apiVersion }: { apiVersion: ShopifyApiVersion }) =>
  buildConnectionSpec(specs, apiVersion);
